<template>
    <div class="deal_index_box">
        <!-- 電子憑證 -->
        <div class="deal_title">
            <div>憑證管理<span>》</span>電子憑證</div>
            <div class="deal_hr">
                <div class="cut_off"></div>
            </div>
        </div>
        <!-- 内容 -->
        <div class="deal_content_box">
            <div class="deal_content_title">電子憑證</div>
            <div class="deal_content">
                <div class="center_box">
                    <!-- 電子憑證 -->
                    <el-form ref="form"  label-width="90px">
                        <el-form-item label="商家編號：" class="center_box_item">
                            {{this.$store.state.uid}}
                        </el-form-item>
                        <el-form-item label="商家名稱：" class="center_box_item">
                            {{storename}}
                        </el-form-item>
						<el-form-item label="UID：" v-if="this.$store.state.uid==1">
						    <el-input class="money_input money_input01" placeholder="" v-model="uidVal" clearable></el-input>
						</el-form-item>
                        <el-form-item label="憑證類型：" class="center_box_item">
                            <el-radio v-model="form.radio" label="1">結算記錄</el-radio>
                            <el-radio v-model="form.radio" label="2">日終餘額</el-radio>
                        </el-form-item>
                        <el-form-item label="申請時間：" class="center_box_item">
                            <el-date-picker
                                v-model="dateValue"
                                type="daterange"
                                align="center" 
								value-format="timestamp"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="開始日期"
                                end-placeholder="結束日期"
                                :picker-options="pickerOptions">
                            </el-date-picker>
                            <span class="deal_content_span">查詢期日不可超過31天</span>
                        </el-form-item>
                    </el-form>
                    <!-- 查詢按钮 -->
                    <div class="inquire_button">
                        <el-button type="primary" @click="LquireFun('ko')">查詢下載</el-button>   
                    </div>
                    <div >
                        <img  id="IframeReportImg" :src="listimg==''?imgsrc:listimg.replace('..','https://pay.taiyigou.com.tw/')" alt="" >
                    </div>
                </div>
            </div>
        </div>
        <!-- deal_index_box -->
		
    </div>
</template>


<script>
import axios from 'axios';
export default {
    name: 'LoginDealCertificates',
    data() {
        return {
			listimg:'',
			imgsrc:require('@/assets/img/login/logindeal/certificates/photo_certificates.jpg'),
			storename:'',
			uidVal:'',
            form:{
                number: '154132156',
                name: '福建逸行股份有限公司',
                radio: '1'
            },
            // 日期
            dateValue: '',
            pickerOptions: {
                shortcuts: [{
                    text: '最近一週',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一個月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                    }
                }]
            }
           
        // return
        }
    },
    methods: {
		inquireFun(e){
			// 交易时间：
			var liss ;
			var onder
			if(e=='ko' ){
				if(this.$store.state.uid==1){
					if(this.uidVal==""){
						this.$message({
						    showClose: true,
						    message:' 請輸入申請人',
						    type: 'error',
						    duration: 1000
						});
						return
					
					}
				}
						
				if(this.dateValue){
					this.end_time = this.dateValue[1].toString();
					this.end_time = this.end_time.substring(0, 10);
					this.start_time = this.dateValue[0].toString();
					this.start_time = this.start_time.substring(0, 10);
					
				}else{
					
				}
				liss='photo';
				onder=this.form.radio;
				
			    
			} else {
				onder=''
				this.end_time='';
				this.start_time='';
				liss='';
			}
			
		
			axios.get(this.$store.state.axioscertificUrl, {
			    params: {
					start_time: this.start_time,
					end_time: this.end_time,
			        uid: this.uidVal ? this.uidVal : this.$store.state.uid,
					status:onder,
					op:liss,
			    }
			}).then((res) => {
			     if(res.data.message){
			        if(res.data.status){
						this.storename = res.data.message;
					   console.log(this.listimg)
	
			        } else {
			            this.$message({
			                showClose: true,
			                message: res.data.message,
			                type: 'error',
			                duration: 1000
			            });
			        }
			     } else {
					  this.listimg=res.data;
					  // this.download(res.data)
			    }
			})
				  
		},
// 		download(e,num){
// 			 this. createIframe(e)
// 		},
// 		createIframe(imgSrc){
// 			if (document.getElementById('IframeReportImg').length === 0){
// 			body.html('<iframe style="display:none;" id="IframeReportImg" name="IframeReportImg" onload="downloadImg();" width="0" height="0" src="about:blank"></iframe>')
// 			}                
// 			if(document.getElementById('IframeReportImg').attr("src") != imgSrc){
// 				document.getElementById('IframeReportImg').attr("src")
// 			}else{
// 					this.downloadImg()
// 			}
// 
// 		},
// 		downloadImg() {
// 			if (document.getElementById('IframeReportImg').src != "about:blank") {
// 				window.frames["IframeReportImg"].document.execCommand("SaveAs");
// 				} 
// 		},
// 
        LquireFun(e){
			this.inquireFun(e)
		}
    },
	created(){
		// 時間：
		let start = new Date(new Date(new Date().toLocaleDateString()).getTime());
		start.setTime(start.getTime() - 3600 * 1000 * 24*7);
		start = start.getTime();
		let end = new Date(new Date(new Date().toLocaleDateString()).getTime());
		end = end.getTime();
		let list = [];
		list[0] = start;
		list[1] = end;
		this.dateValue = list;
	    
	    this.inquireFun('li');
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 交易管理》交易订单 */
    .deal_index_box {
        margin: 20px;
        font-size: 15px;
        color: black;
    }
    .deal_title {
        display: flex;
        justify-content: flex-start;
        margin: 30px 0;
    }
    .deal_title span {
        margin-left: 15px;
        margin-right: 8px;
    }
    .deal_title .deal_hr {
        flex: 1;
        margin-left: 18px;
    }
    .deal_title .deal_hr .cut_off {
        height: 3px;
        background: black;
        margin-top: 8px;
    }
	.img_maxbox {
		overflow: hidden;
		height: 200px;
	}
	.img_box {
		width: 200px;
		height: 200px;
	}
/* 内容 */
    .time_box {
        font-size: 17px;
        margin-bottom: 33px;
    }
    .time_box > span {
        color: #e73262;
        margin: 0 5px;
    }
    .datetime_box > span {
        margin: 10px;
    }
    .deal_content_box {
        font-size: 13px;
        margin-top: 20px;
    }
    .deal_content_title {
        height: 42px;
        background: #666666;
        line-height: 42px;
        color: white;
        padding-left: 14px;
    }
    .deal_content {
        box-sizing: border-box;
        /* height: 53.6vw; */
        min-height: 500px;
        border: 1px solid #666666;
        background: #ffffff;
        padding: 38px 20px;
        padding-top: 26px;
    }
    .center_box {
        width: 900px;
        margin: 10px 65px;
    }
    .deal_content_span {
        margin-left: 23px;
        font-size: 11px;
        color: #e73262;
    }
    .deal_content_tab_first {
        width: 960px;
    }
    .money_box span {
        margin: 0 10px;
    }
    .money_input {
        width: 140px;
        /* margin-left: 4px; */
    }
    .money_input01 {
        margin-left: 4px;
    }
    .inquire_button {
        padding: 10px;
    }
   .center_box_item {
       margin: 3px 0;
   }
</style>
